import { render, staticRenderFns } from "./NotificationsButton.vue?vue&type=template&id=295ab5be&"
import script from "./NotificationsButton.vue?vue&type=script&lang=js&"
export * from "./NotificationsButton.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
